import {Line} from "react-konva";
import {gridToImage} from "@/dungeons/geometry/Coordinates.ts";
import type {LevelGeometryDocument} from "@/dungeons/model/DungeonGeometry.ts";
import type {SelectedGeometryFeature} from "./GeometryEditorTypes.ts";
import {doorHitPoints} from "./DoorAppearance.ts";

export default function GeometryHitOverlays({geometry, selection, zoom, onSelect}: {
    geometry: LevelGeometryDocument;
    selection?: SelectedGeometryFeature;
    zoom: number;
    onSelect: (selection: SelectedGeometryFeature) => void;
}) {
    return <>
        {geometry.transitions.filter(item => selection?.type !== "transition" || item.id !== selection.id)
            .map(item => <Line key={item.id} points={item.points.flatMap(point => {
                const image = gridToImage(point, geometry.registration);
                return [image.x, image.y];
            })} closed fill="rgba(0,0,0,0.001)" stroke="rgba(0,0,0,0.001)"
                strokeWidth={1 / zoom} hitStrokeWidth={14 / zoom}
                onClick={event => {
                    event.cancelBubble = true;
                    onSelect({type: "transition", id: item.id});
                }}/>) }
        {geometry.walls.filter(wall => selection?.type !== "wall" || wall.id !== selection.id).map(wall => {
            const points = wall.points.flatMap(point => {
                const image = gridToImage(point, geometry.registration);
                return [image.x, image.y];
            });
            return <Line key={wall.id} points={points} stroke="rgba(0,0,0,0.001)"
                         strokeWidth={1 / zoom} hitStrokeWidth={14 / zoom} lineCap="round" lineJoin="round"
                         onClick={event => {
                             event.cancelBubble = true;
                             onSelect({type: "wall", id: wall.id});
                         }}/>;
        })}
        {geometry.doors.filter(door => selection?.type !== "door" || door.id !== selection.id).map(door => {
            const start = gridToImage(door.start, geometry.registration);
            const end = gridToImage(door.end, geometry.registration);
            return <Line key={door.id} points={doorHitPoints(start, end, zoom)} stroke="rgba(0,0,0,0.001)"
                         strokeWidth={1 / zoom} hitStrokeWidth={16 / zoom} lineCap="butt"
                         onClick={event => {
                             event.cancelBubble = true;
                             onSelect({type: "door", id: door.id});
                         }}/>;
        })}
    </>;
}
